
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { ApiMethod } from '../../apimethods/api-method';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

declare var $;

@Component({
  selector: 'app-ext-api-config',
  templateUrl: './ext-api-config.component.html',
  styleUrls: ['./ext-api-config.component.css']
})
/** extAPI-config component*/
export class ExtApiconfigComponent implements OnInit{

  showModal: boolean;
  title: string;
  dataTable: any;
  dtOptions: any;
  tableData = [];
  @ViewChild('dataTable', { static: false }) table;
  dataSet: any;
  ApplicationName: any;
  APIname: any;
  APImethod: any;
  isDisabled: boolean;// to enable/disable application name 
  isHiddenAdd: boolean;
  isHiddenupdate: boolean;// hide/display the Add button

  /** extAPI-config ctor */
  constructor(private router: Router) {

    localStorage.aEID = 0;

  }

  ngOnInit(): void {
    
    $('#ddlApplication').select2({
      placeholder: "Select", dropdownParent: "#myModal",
      allowClear: true, tags: true //feature to enable text input and clear the data
    });

    $('#ddlApplication').val([]).trigger('change');// enabling the click event

    $('#ddlApiName').select2({
      placeholder: "Select", dropdownParent: "#myModal",
      allowClear: true, tags: true
    });
    $('#ddlApiName').val([]).trigger('change');

    $('#ddlApiMethod').select2({
      placeholder: "Select", dropdownParent: "#myModal",
      allowClear: true, tags: true
    });
    $('#ddlApiMethod').val([]).trigger('change');

    //function call to fill the dropdown
    this.GetApplicationName();
    this.GetAPIName();
    this.GetAPIMethod();

    //datagrid loading fn
    this.getExtAPIconfiguration();


    this.isDisabled = true;//application
    this.isHiddenAdd = true;
    this.isHiddenupdate = false

      }
 
  //Get Application name list
    GetApplicationName(): void {
      let nPublisherId = localStorage.aPubID;

      //api call to get application list
        ApiMethod.getMethod('gen/ExtAPI-ApplicationName/' + localStorage.aLoginID + '/' + nPublisherId).subscribe(
        result => {
               this.ApplicationName = result.aApplicationName;
         }, error => {

               $("#LoadingImage").hide();
            ngswal("Warning !", error.message, "warning");
        });
  }

  //Get API name list
    GetAPIMethod(): void {
      let nPublisherId = localStorage.aPubID;
       //api call to get apimethod list
      ApiMethod.getMethod('gen/ExtAPI-Method/' + localStorage.aLoginID + '/' + nPublisherId).subscribe(
      result => {
        this.APImethod = result.aAPImethod;

      }, error => {
        $("#LoadingImage").hide();
          ngswal("Warning !", error.message, "warning");
      });
  }


  //Get API name list
  GetAPIName(): void {
    let nPublisherId = localStorage.aPubID;
     //api call to get apiname list
    ApiMethod.getMethod('gen/ExtAPI-Name/' + localStorage.aLoginID + '/' + nPublisherId).subscribe(
      result => {
        this.APIname = result.aAPIname;
         }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error.message, "warning");
      });
  }


  //Method to load the datagrid
  getExtAPIconfiguration(): void {
    $("#LoadingImage").show();
    let nPublisherId = localStorage.aPubID;

    //api call to get the datagrid data
    ApiMethod.getMethod('gen/ExtAPIConfiguration/' + localStorage.aLoginID + '/' + nPublisherId).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.dataSet = JSON.stringify(result.aExtConfigList); // conversion from json data to string value
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = result.aColListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 75);
        dataItem.modulename = 'APIConfiguration';
        dataItem.rowSelect = true;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);//custom function call for dynamic datatable
        
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }


  //Delete a record
  Delete() {
    ngswal({
      title: "Are you sure to delete the Data?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnDeleteConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel! :)", "warning");
        }
      });
  }
  //delete a record after confirmation
  DeleteConfirm() {

    $('#LoadingImage').show();

    //api call to delete
    ApiMethod.postMethod("gen/DeleteExtAPIDetails/" + localStorage.aEID + '/' + localStorage.aLoginID, "").subscribe(
      result => {
        $("#LoadingImage").hide();
        this.getExtAPIconfiguration();
        this.hide();
        ngswal({
          position: 'top-end',
          type: "success",
          title: "Deleted !",
          text: result,
          showConfirmButton: false,
          timer: 1500
        });

        this.getExtAPIconfiguration();//reload grid after a delete

      },
      error => {
        ngswal("Failed !", error.message, "warning");
      }
    );


  }

  //clearing the form data
  clearData(): void {
    let form: NgForm = $('form#frmExtAPIConf');
    $("#ddlApplication").val("Select").change();
    $("#ddlApiName").val("Select").change();
    $("#ddlApiMethod").val("Select").change();

    $("txtapiUrl").val("");
    $("txtApiHeaders").val("");
    $("txtApiKeyValue").val("");
    $("txtDescription").val("");
    $("txtPayLoad").val("");
    
    form[0].reset();

  }

  //Show ExternalConfig data control popup for add/update click
  show(): void{

   this.clearData();
   
   // alert(localStorage.aEID);
    
    if (localStorage.aEID != 0) { // checks whether the call is frm edit btn click(holds the row id) or new btn click( row id is 0)

      $("#LoadingImage").show();
      //api call to display the data on grid for the seleted row
      ApiMethod.getMethod('gen/ExtAPIDetails-ByID/' + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImage").hide();

          let itemL = result.aExtConfigListById;

          //assigns value to the form elements

          $("#ddlApplication").val(itemL.Application).change();
          $("#ddlApiName").val(itemL.ApiName).change();
          $("#ddlApiMethod").val(itemL.ApiMethod).change();
          $("#txtapiUrl").val(itemL.ApiUrl);
          $("#txtApiHeaders").val(itemL.ApiHeaders);
          $("#txtApiKeyValue").val(itemL.ApiKeyValue);
          $("#txtDescription").val(itemL.Description);
          $("#txtPayLoad").val(itemL.PayloadData);

          this.isDisabled = true;//txtapplication disabled
          this.isHiddenAdd = true;
          this.isHiddenupdate = false;// update shown add hidden

        

        },
        error => {
          ngswal("Failed !", error.message, "warning");
        }
      );
    }
    else {
      this.clearData();
      this.isDisabled = false;//txt application disabled
      this.isHiddenAdd = false;// show add
      this.isHiddenupdate = true;// hide update

    }
    this.showModal = true; // Show-Hide Modal Check
    this.title = "External API Configuration Details";    // Dynamic Data
  }

  //Bootstrap Modal Close event
  hide() {
    this.clearData();
    this.showModal = false;
  }

  //Update ProofingType details method
  updateExtAPIConfigDetails(): void {

    if ($('#ddlApplication').val() == 'Select' || $('#ddlApplication').val().trim() == '') {
      ngswal("Warning !", "Enter Application  !", "warning");
    }
    else if ($('#ddlApiName').val() == 'Select' || $('#ddlApiName').val().trim() == '') {
      ngswal("Warning !", "Enter Application Name !", "warning");
    }
    else if ($('#ddlApiMethod').val().trim() == 'Select' || $('#ddlApiMethod').val().trim() == '') {
      ngswal("Warning !", "Enter API Method !", "warning");
    }
    //else if ($('#txtapiUrl').val().trim() == '') { // validations for future use if required
    //  ngswal("Warning !", "Enter API Url !", "warning");
    //}
    //else if ($('#txtApiHeaders').val().trim() == '') {
    //  ngswal("Warning !", "Enter API Header !", "warning");
    //}
    //else if ($('#txtApiKeyValue').val().trim() == '') {
    //  ngswal("Warning !", "Enter API Key Value!", "warning");
    //}
    //else if ($('#txtDescription').val().trim() == '') {
    //  ngswal("Warning !", "Enter Description !", "warning");
    //}
    //else if ($('#txtPayLoad').val().trim() == '') {
    //  ngswal("Warning !", "Enter Payload !", "warning");
    //}
    else {
      $("#LoadingImagePopup").show();
      var aExtAPIConfig = {

        Id: localStorage.aEID,
        Application: $('#ddlApplication').val(),
        ApiName: $('#ddlApiName').val(),
        ApiMethod: $('#ddlApiMethod').val(),
        APIUrl: $('#txtapiUrl').val(),
        ApiHeaders: $('#txtApiHeaders').val(),
        APIKeyvalue: $('#txtApiKeyValue').val(),
        Description: $('#txtDescription').val(),
        PayloadData: $('#txtPayLoad').val(),
        PublisherId: localStorage.aLoginID,
       
      };
      //api call to update the record
      ApiMethod.postMethod('gen/updateExtAPIDetails', aExtAPIConfig).subscribe(
        response => {
          //after update reload the grid to reflect the changes
          this.getExtAPIconfiguration();

          $("#LoadingImagePopup").hide();
          this.hide();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: response,
            showConfirmButton: false,
            timer: 1500
          });
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );

    }
  }

  //Add External API CONFIGURATION details
  AddExtAPIConfigDetails(): void {
    if ($('#ddlApplication ').val().trim() == 'Select' || $('#ddlApplication').val().trim()  == '') {
    ngswal("Warning !", "Enter Application  !", "warning");
  }
    else if ($('#ddlApiName').val() == 'Select' || $('#ddlApiName').val().trim() == '') {
    ngswal("Warning !", "Enter Application Name !", "warning");
  }
    else if ($('#ddlApiMethod').val().trim() == 'Select' || $('#ddlApiMethod').val().trim() == '') {
    ngswal("Warning !", "Enter API Method !", "warning");
  }
 
  else {

  $("#LoadingImagePopup").show();
    var aExtAPIConfig = {
      Id: localStorage.aEID,
      Application: $('#ddlApplication').val(),
      ApiName: $('#ddlApiName').val(),
      ApiMethod: $('#ddlApiMethod').val(),
      APIUrl: $('#txtapiUrl').val(),
      ApiHeaders: $('#txtApiHeaders').val(),
      APIKeyvalue: $('#txtApiKeyValue').val(),
      Description: $('#txtDescription').val(),
      PayloadData: $('#txtPayLoad').val(),
      PublisherId: localStorage.aLoginID,
    };
//api call to insert a new record
    ApiMethod.postMethod('gen/AddExtAPIDetails', aExtAPIConfig).subscribe(
    response => {
      this.getExtAPIconfiguration();
      $("#LoadingImagePopup").hide();
      this.hide();

        if (response == 'Ext-Api-name already exist!') {
          ngswal({
            position: 'top-end',
            type: "warning",
            title: "Please Check",
            text: response,
            showConfirmButton: true,
            // timer: 1500
          });
        }
        else {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Success",
            text: response,
            showConfirmButton: true,
            // timer: 1500
          });
        }
    },
    error => {
      ngswal("Failed !", error.error.Message, "warning");
      $("#LoadingImagePopup").hide();
    }
  );

  }
  }



}
